import { DealerLocatorDrawerWrapper } from './dealer-locator-drawer-wrapper';
import { DealerLocatorContent } from './dealer-locator-content';
import { StoreAddress } from './types';
import { TranslationsProvider } from 'providers/translations-provider';
import { dealerLocatorDrawerTranslationKeys } from './constants/translation-keys';

interface DealerLocatorDrawerProps {
  autoSearch?: boolean;
  isADP?: boolean;
  storeAddress?: StoreAddress;
  restrictedDealerStores?: string[];
}

export const DealerLocatorDrawer = ({
  autoSearch,
  isADP = false,
  storeAddress,
  restrictedDealerStores
}: DealerLocatorDrawerProps) => (
  <TranslationsProvider keys={dealerLocatorDrawerTranslationKeys}>
    <DealerLocatorDrawerWrapper>
      <DealerLocatorContent
        autoSearch={autoSearch}
        isADP={isADP}
        storeAddress={storeAddress}
        restrictedDealerStores={restrictedDealerStores}
      />
    </DealerLocatorDrawerWrapper>
  </TranslationsProvider>
);
